import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'upsc-logo-dd',
    templateUrl: './logo-dd.component.html',
    styleUrls: ['./logo-dd.component.scss'],
})
export class DeliveryDefenseLogoComponent {
    @Input() public shouldShowTM = false;
    @Input() public width = '56.4px';
    @Input() public height = '59.623px';

    @HostBinding('class') public hostClass = 'logo-dd';
    @HostBinding('style.width') get hostWidth() {
        return `${this.width}` || '100%';
    }

    @HostBinding('style.height') get hostHeight() {
        return `${this.height}` || '100%';
    }

    @HostBinding('style.font-size') get hostFontSize() {
        return `calc(${this.width} / 3)` || '1rem';
    }

    constructor() {
    }
}
